import { ReactNode, useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import { useLocation } from 'react-router-dom';

import './style.scss';

interface Props {
	fullWidth?: boolean;
	className?: string;
	children: ReactNode,
}

export default function Content( { fullWidth = false, className = '', children = null }: Props ) {
	const location = useLocation();
	const contentRef = useRef<HTMLElement>( null );
	const [ isRouteTransitioning, setIsRouteTransitioning ] = useState( true );

	useEffect( () => {
		contentRef.current?.scrollTo( { top: 0, left: 0 } );
		setIsRouteTransitioning( true );
		const timeout = setTimeout( () => setIsRouteTransitioning( false ), 260 );

		return () => clearTimeout( timeout );
	}, [ location.pathname, location.search ] );

	return (
		<div className="content-frame">
			<main
				ref={ contentRef }
				className={ clsx(
					'content',
					{
						'content--fullwidth': fullWidth,
						'content--route-transitioning': isRouteTransitioning,
					},
					className
				) }
			>
				{ children }
			</main>
		</div>
	);
}
